// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-491531e0],.logo-img[data-v-491531e0]{margin-left:10px}.logo-img[data-v-491531e0]{width:50px;height:50px;border-radius:50%}@media only screen and (max-width:600px){.logo-img[data-v-491531e0]{width:30px;height:30px;border-radius:50%}.logo[data-v-491531e0]{display:flex;flex-direction:column;justify-content:left}}.suspension-bar[data-v-491531e0]{z-index:9;bottom:0!important;top:unset}.copyright[data-v-491531e0]{line-height:80px;color:#fff}", ""]);
// Exports
module.exports = exports;
